import { useCallback, useState } from "react";
import { useApi } from "../apiCall/useApi";
import Joi from "joi";
import { Urls } from "../../../utils/constant";
import { size } from "lodash";
import { useSnackbar } from "notistack";
import {
  hidePageLoader,
  showPageLoader,
} from "../../reducers/Common/PageLoader/PageLoader.reducer";
import { useDispatch } from "react-redux";
import Api from "../../../utils/api.utils";
import useFullPageLoader from "../Common/PageLoader/useFullPageLoader";
import { setHelpData } from "../../reducers/Help/helpForm.reducer";

export const helpEntrySchema = Joi.object({
  title: Joi.string().required().messages({
    "string.empty": "Title is required.",
  }),
  subTitle: Joi.string().required().messages({
    "string.empty": "Sub Title is required.",
  }),
  detail: Joi.string().required().messages({
    "string.empty": "Details is required.",
  }),
});

export function useHelpForm({ existingStatus }) {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const { apiPost } = useApi();
  const [loading, setLoading] = useState(false);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [status, setStatus] = useState(existingStatus === 2 ? 0 : 1);
  const [Id, setId] = useState("");
  const [Title, setTitle] = useState("");
  const [SubTitle, setSubTitle] = useState("");
  const [Details, setDetails] = useState("");

  const handleDeleteId = useCallback(
    (row) => {
      setId(row.id);
      setTitle(row.title);
      setSubTitle(row.sub_title);
      setDetails(row.detail);
    },
    [Id, Title, Details, SubTitle]
  );
  const HelpEntry = useCallback(
    async ({ title, subTitle, detail }) => {
      const status_Val = status === false ? 2 : status === 0 ? 2 : 1;
      if (loading) return;
      setLoading(true);
      try {
        dispatch(showPageLoader());
        // const formattedReportDate = format(ReportDate, 'yyyy-MM-dd');
        const { data } = await apiPost({
          url: Urls.helpAdd(),
          data: {
            title: title,
            sub_title: subTitle,
            detail: detail,
            status: status_Val,
            insert_by: "",
          },
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        });
        if (data && data.id && data.id.length === 36) {
          // Adjust condition if necessary
          enqueueSnackbar("Help Data Added Successfully.", {
            variant: "success",
          });
          return true;
        }

        setLoading(false);
        dispatch(hidePageLoader());
      } catch (err) {
        dispatch(hidePageLoader());
        console.log(err);
        setLoading(false);
        return false;
      }
    },
    [status, loading]
  );

  const helpUpdate = useCallback(
    async ({ id, title, subTitle, detail }) => {
      if (loading) return;
      setLoading(true);
      const status_Val = status === false ? 2 : status === 0 ? 2 : 1;
      try {
        dispatch(showPageLoader());
        const { data } = await apiPost({
          url: Urls.helpUpdate(),
          data: {
            id: id,
            title: title,
            sub_title: subTitle,
            detail: detail,
            status: status_Val,
            update_by: "",
          },
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        });
        if (size(data.id) === 36) {
          enqueueSnackbar("Help Data Updated Successfully.", {
            variant: "success",
          });
          return true;
        }

        setLoading(false);
        dispatch(hidePageLoader());
      } catch (err) {
        dispatch(hidePageLoader());
        console.log(err);
        setLoading(false);
        return false;
      }
    },
    [status, loading]
  );

  const helpDelete = useCallback(async () => {
    //   const formattedReportDate = format(ReportDate, 'yyyy-MM-dd');
    try {
      dispatch(showPageLoader());
      const { data } = await apiPost({
        url: Urls.helpUpdate(),
        data: {
          id: Id,
          title: Title,
          sub_title: SubTitle,
          detail: Details,
          status: 2,
          update_by: "",
        },
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      });

      if (size(data.id) === 36) {
        enqueueSnackbar("Lab Data Deleted Successfully.", {
          variant: "success",
        });
        return true;
      }

      setLoading(false);
      dispatch(hidePageLoader());
    } catch (err) {
      dispatch(hidePageLoader());
      console.log(err);
      setLoading(false);
      return false;
    }
  }, [status, Id, Title, SubTitle, Details]);

  const getHelpById = useCallback(
    async (id) => {
      if (loading) return;
      setLoading(true);
      try {
        dispatch(showPageLoader());

        const { data } = await apiPost({
          url: Urls.getHelpById(),
          data: {
            id: id,
          },
        });

        dispatch(setHelpData(data));
        setLoading(false);
        dispatch(hidePageLoader());
      } catch (err) {
        dispatch(hidePageLoader());
        console.log(err);
        setLoading(false);
        return false;
      }
    },
    [loading]
  );

  const handleStatusComboChange = useCallback((event) => {
    if (event.target.checked === 1) {
      setStatus(event.target.checked);
    } else {
      setStatus(event.target.checked);
    }
  }, []);

  return {
    loader,
    loading,
    status,
    helpEntrySchema,
    handleStatusComboChange,
    HelpEntry,
    helpUpdate,
    getHelpById,
    handleDeleteId,
    helpDelete,
  };
}
